///////////////////////////////////////////////////////
// Outline
///////////////////////////////////////////////////////
/*
    1. Methods
        a. showEscInfoModal
    
    2. Property Accessors            
        a. getData
        b. setData
*/

(function () {
    'use strict';

    angular
        .module('app.courseHandicap')
        .component('sc3CourseListPanel', {
            templateUrl: 'app/course-handicap/course-list-panel.component.html',
            controller: CourseListPanelComponent,
            bindings: { model: '<' }
        });

    CourseListPanelComponent.$inject = ['escInfoModal'];
    function CourseListPanelComponent(escInfoModal) {
        // Variables
        var ctrl = this;

        // Properties
        Object.defineProperty(ctrl, 'data', { get: getData });
        Object.defineProperty(ctrl, 'status', { get: getStatus });

        // Methods
        ctrl.showEscInfoModal = showEscInfoModal;

        ///////////////////////////////////////////////////////
        // Methods
        ///////////////////////////////////////////////////////
        function showEscInfoModal() {
            escInfoModal().result.catch(noop);
        }

        ///////////////////////////////////////////////////////
        // Property Accessors
        ///////////////////////////////////////////////////////
        function getData() {
            return ctrl.model.data;
        }
        function getStatus() {
            var facility = ctrl.data.facility,
                courses = facility && facility.courses;
            return courses && courses.length && courses[0].status || 'NoData';
        }
    }
})();